import { render } from "./more-unreads.vue?vue&type=template&id=48e30d29"
import script from "./more-unreads.vue?vue&type=script&lang=js"
export * from "./more-unreads.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__